import { AfterContentInit, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePickerType, FilterOperator, FilterOptions, FilterOptionsType, InvoiceProcessorService, ISAPI, ISColumn, ISFilterAPI, ISPagination, ISSelectDatasource, ISSelectOption, ISSelectModule, MVListingConfigs, MVFilter, MVPagination } from 'is-lib';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder, AbstractControl, ValidatorFn, FormControlOptions, Form } from '@angular/forms';
import { UsersService } from 'src/app/services/users.service';
import { ClientPortalUser } from 'src/app/models/Client';
import { BehaviorSubject, distinctUntilChanged, firstValueFrom, forkJoin, Observable, Subscription, map, switchMap, tap, debounceTime, of, filter, Subject, takeUntil } from 'rxjs';
import { CreateEntity, Entity, EntityExistenceAndPermissions, ResolvedEntity } from 'src/app/models/Entity';
import { EntitiesService } from 'src/app/services/entities.service';
import { ServerResponse } from 'src/app/models/ServerResponse';
import { GroupingsService } from 'src/app/services/groupings.service';
import { CreateElectricityGrouping, CreateNaturalGasGrouping, IGrouping } from 'src/app/models/Grouping';
import { EnergyMetersService } from 'src/app/services/energyMeters.service';
import { RegExpPatterns } from 'src/app/helpers/reg-exp-patterns';
import { environment } from 'src/environments/environment';
import { CreateEnergyOpportunityElectricityMeters, CreateEnergyOpportunityNaturalGasMeters, CreateOpportunity } from 'src/app/models/Opportunity';
import { OpportunitiesService } from 'src/app/services/opportunities.service';
import { AddressesService } from 'src/app/services/addresses.service';
import { CreateElectricityMeterConsumption, CreateNaturalGasMeterConsumption, ElectricityMeterConsumption, NaturalGasMeterConsumption } from 'src/app/models/EnergyConsumptions';
import * as dateFns from 'date-fns'
import { SnackBarService } from 'src/app/services/snackbar.service';
import { SnackBarType } from 'src/app/models/Snackbar';
import * as _ from 'lodash';
import { ContactTypes, contractTypes } from 'src/app/constants';
import { TranslateService } from '@ngx-translate/core';
import { EquipmentAddDialogComponent } from './equipment/add-equipment-dialog.component';
import { SuppliersService } from 'src/app/services/suppliers.service';
import { Supplier } from 'src/app/models/Supplier';
import { ConsumptionsFormGroup, DataComparisonFormGroup, ElectricityEquipmentFormGroup, EnergyMeter, EntityFormGroup, InvoiceDataFormGroup, NaturalGasEquipmentFormGroup } from '../../energy-meters/energy-meters-types';
import { InvoiceProcessorResult, EnergyMeter as ISLibEnergyMeter } from 'is-lib/lib/is-invoice-processor/invoice-processor-types';
import { NewOpportunityFormGroup } from '../types/opportunity-types';
import { ContractsService } from 'src/app/services/contracts.service';
import { format } from 'date-fns';
import { CreateElectricityMeterES, CreateElectricityMeterPT } from 'src/app/models/EnergyMeter';
import { UserProfile } from 'src/app/models/UserProfile';

@Component({
    selector: 'app-new-opportunity-form',
    templateUrl: './new-opportunity-form.component.html',
    styleUrls: ['./new-opportunity-form.component.scss'],
})

export class NewOpportunityFormComponent implements OnInit, AfterContentInit, OnDestroy {
    //#region Others TEMP
    @ViewChild('scrollableContent') scrollableContent!: ElementRef;

    readonly addEquipmentErrorCodes = { 
        'duplicateCode': 'DUPLICATE_EQUIPMENT_CODE',
        'invalidEquipmentCode': 'INVALID_EQUIPMENT_CODE'
    }

    consumptionsDictionary = new Map<number, boolean>();
    hasChanges: boolean = false;

    pressureLevel: string = '';
    tariffOption: string = '';
    tier: string = '';

    showStepperShadow = false;
    showFooterShadow = false;
    contractTypes: ISSelectOption[];
    contactTypes = ContactTypes;
    equipmentSelectedTabs: number[] = [];

    selectedGroupingForElectricity: boolean = false;
    selectedGroupingForNaturalGas: boolean = false;

    dateType: DatePickerType = DatePickerType.date
    countryCode: string = '';

    showingAddInterface: boolean = false;
    addEquipmentType: 'electricity' | 'gas' | null = 'electricity';
    addEquipmentGroup = new FormGroup({ equipmentCode: new FormControl('') });
    addEquipmentInvoiceFile: File | null = null;
    selectedEquipmentIndex: number | null = null;
    selectedEquipmentFormGroup: FormGroup<ElectricityEquipmentFormGroup | NaturalGasEquipmentFormGroup> | null = null;

    isFetchingEntity: boolean = false;
    fetchedEntities: ResolvedEntity[] = [];
    fetchedSupplier!: Supplier | null;

    ownEntity: ResolvedEntity = {
        id: null,
        entity: null,
        permissions: {
            exists: false,
            haveActiveContracts: false,
            id: '',
            name: `${this._userData.firstName}${this._userData.lastName}`.trim(),
            tin: ''
        } 
    };

     otherEntity: ResolvedEntity = {
        id: null,
        entity: null,
        permissions: {
            exists: false,
            haveActiveContracts: false,
            id: '',
            name: '',
            tin: ''
        }
    };


    subscriptions: Subscription[] = [];
    // Read requests are cancelled when the dialog closes; submission (write) requests are deliberately not, so a submit is never left half done
    private readonly _destroy$ = new Subject<void>();
    //#endregion

    //#region FORM -----------------------------
    newOpportunityForm: FormGroup<NewOpportunityFormGroup> = new FormGroup<NewOpportunityFormGroup>({
        //Entity Data
        entity: new FormGroup<EntityFormGroup>({
            id: new FormControl<string | null>(null),
            tin: new FormControl<number | null>(null, [Validators.required, Validators.min(100000000), Validators.max(999999999)]),
            name: new FormControl<string | null>(null, [Validators.required]),
            address: new FormGroup<DataComparisonFormGroup<string | null>>({
                comparisonResult: new FormControl<'match' | 'mismatch' | 'notFound' | null>(null),
                finalValue: new FormControl<string | null>(null),
                invoiceValue: new FormControl<string | null>(null),
                serverValue: new FormControl<string | null>(null)
            }),
            postalCode: new FormGroup<DataComparisonFormGroup<string | number | null>>({
                comparisonResult: new FormControl<'match' | 'mismatch' | 'notFound' | null>(null),
                finalValue: new FormControl<string | null>(null),
                invoiceValue: new FormControl<string | null>(null),
                serverValue: new FormControl<string | null>(null),
                finalId: new FormControl<number | null>(null)

            }, [Validators.required, Validators.pattern(this._zipCodeRegexpPattern())]),
            parish: new FormGroup<DataComparisonFormGroup<string | number | null>>({
                comparisonResult: new FormControl<'match' | 'mismatch' | 'notFound' | null>(null),
                finalValue: new FormControl<string | null>(null),
                invoiceValue: new FormControl<string | null>(null),
                serverValue: new FormControl<string | null>(null),
                finalId: new FormControl<string | null>(null)
            }),
            email: new FormGroup<DataComparisonFormGroup<string | null>>({
                comparisonResult: new FormControl<'match' | 'mismatch' | 'notFound' | null>(null),
                finalValue: new FormControl<string | null>(null),
                invoiceValue: new FormControl<string | null>(null),
                serverValue: new FormControl<string | null>(null)
            }),
            phoneNumber: new FormGroup<DataComparisonFormGroup<string | null>>({
                comparisonResult: new FormControl<'match' | 'mismatch' | 'notFound' | null>(null),
                finalValue: new FormControl<string | null>(null),
                invoiceValue: new FormControl<string | null>(null),
                serverValue: new FormControl<string | null>(null)
            })
        }),

        //Group Data
        isOwnTin: new FormControl<boolean | null>(null),
        expectedStartDate: new FormControl<Date | null>(null, [Validators.required]),
        contractType: new FormControl<string | null>(null, [Validators.required]),
        groupingId: new FormControl<string | null>(null, [Validators.required]),
        groupingName: new FormControl<string | null>(null, [Validators.required]),
        loyaltyPeriod: new FormControl<number | null>(null),
        name: new FormControl<string | null>(null),
        opportunityId: new FormControl<string | null>(null),

        //Equipments
        electricityEquipments: new FormArray<FormGroup<ElectricityEquipmentFormGroup>>([]),
        naturalGasEquipments: new FormArray<FormGroup<NaturalGasEquipmentFormGroup>>([]),
    });
    //#endregion FORM --------------------------

    //#region DATASOURCES ----------------------
    tensionLevelDatasource$: BehaviorSubject<ISSelectDatasource> = new BehaviorSubject<ISSelectDatasource>( //ELECTRICITY TENSION LEVELS
        {
            apiUrl: `${environment.apiUrl}Electricity/${this._userService.userCountryCode}/TensionLevels`,
            columns: [
                new ISColumn('id', 'ID'),
                new ISColumn('description', 'DESCRIPTION', new FilterOptions('', FilterOptionsType.text, FilterOperator.contains))
            ],
            pagination: new ISPagination(25, 0),
            totalItems: 0,
            codeBTN: false,
            codeBtnDialog: false,
            codeBtnId: null
        }
    );

    timeCyclesDatasource$: BehaviorSubject<ISSelectDatasource> = new BehaviorSubject<ISSelectDatasource>( //ELECTRICITY TIME CYCLES
        {
            apiUrl: `${environment.apiUrl}Electricity/${this._userService.userCountryCode}/TimeCycles`,
            columns: [
                new ISColumn('id', 'ID'),
                new ISColumn('description', 'DESCRIPTION', new FilterOptions('', FilterOptionsType.text, FilterOperator.contains))
            ],
            pagination: new ISPagination(25, 0),
            totalItems: 0,
            codeBTN: false,
            codeBtnDialog: false,
            codeBtnId: null
        }
    );

    countTypesDatasource$: BehaviorSubject<ISSelectDatasource> = new BehaviorSubject<ISSelectDatasource>( //COUNTING CYCLE TYPES
        {
            apiUrl: `${environment.apiUrl}Electricity/${this._userService.userCountryCode}/CountingCycles`,
            columns: [
                new ISColumn('id', 'ID'),
                new ISColumn('description', 'DESCRIPTION', new FilterOptions('', FilterOptionsType.text, FilterOperator.contains))
            ],
            pagination: new ISPagination(25, 0),
            totalItems: 0,
            codeBTN: false,
            codeBtnDialog: false,
            codeBtnId: null,
            body: []
        }
    );

    electricityTariffDatasource$: BehaviorSubject<ISSelectDatasource> = new BehaviorSubject<ISSelectDatasource>( //TARIFFS
        {
            apiUrl: undefined,
            columns: [
                new ISColumn('id', 'ID'),
                new ISColumn('description', 'DESCRIPTION', new FilterOptions('', FilterOptionsType.text, FilterOperator.contains))
            ],
            pagination: new ISPagination(25, 0),
            totalItems: 0,
            codeBTN: false,
            codeBtnDialog: false,
            codeBtnId: null
        }
    );

    pressureLevelDatasource$: BehaviorSubject<ISSelectDatasource> = new BehaviorSubject<ISSelectDatasource>( //PRESSURE LEVELS
        {
            apiUrl: `${environment.apiUrl}NaturalGas/${this._userService.userCountryCode}/PressureLevels`,
            columns: [
                new ISColumn('id', 'ID'),
                new ISColumn('description', 'DESCRIPTION', new FilterOptions('', FilterOptionsType.text, FilterOperator.contains))
            ],
            pagination: new ISPagination(25, 0),
            totalItems: 0,
            codeBTN: false,
            codeBtnDialog: false,
            codeBtnId: null
        }
    );

    tariffOptionDatasource$: BehaviorSubject<ISSelectDatasource> = new BehaviorSubject<ISSelectDatasource>( //TARIFFS
        {
            apiUrl: `${environment.apiUrl}NaturalGas/${this._userService.userCountryCode}/TariffOptions`,
            columns: [
                new ISColumn('id', 'ID'),
                new ISColumn('description', 'DESCRIPTION', new FilterOptions('', FilterOptionsType.text, FilterOperator.contains))
            ],
            pagination: new ISPagination(25, 0),
            totalItems: 0,
            codeBTN: false,
            codeBtnDialog: false,
            codeBtnId: null
        }
    );

    tierDatasource$: BehaviorSubject<ISSelectDatasource> = new BehaviorSubject<ISSelectDatasource>( //TIERS
        {
            apiUrl: `${environment.apiUrl}NaturalGas/${this._userService.userCountryCode}/Tiers`,
            columns: [
                new ISColumn('id', 'ID'),
                new ISColumn('description', 'DESCRIPTION', new FilterOptions('', FilterOptionsType.text, FilterOperator.contains))
            ],
            pagination: new ISPagination(25, 0),
            totalItems: 0,
            codeBTN: false,
            codeBtnDialog: false,
            codeBtnId: null
        }
    );

    // Options for the parish drop‑down.  Each equipment has its own list so we keep
    // a two‑dimensional array indexed by equipment index. Initialized as empty so
    // bindings never see undefined.
    parishOptions: ISSelectOption[][] = []; //Array with parish options per equipment

    loyaltyPeriodOptions: ISSelectOption[] = [ //Loyalty Periods
        new ISSelectOption(12, '12 ' + this._translateService.instant('MONTHS')),
        new ISSelectOption(18, '18 ' + this._translateService.instant('MONTHS')),
        new ISSelectOption(24, '24 ' + this._translateService.instant('MONTHS'))
    ];
    //#endregion DATASOURCES --------------------

    //#region STEPPER --------------------------
    steps: any[] = [ //Steps in form
        { label: this._translateService.instant('UPLOAD_INVOICE'), icon: 'upload' },
        { label: this._translateService.instant('FILL_DATA'), icon: 'pencil' },
        { label: this._translateService.instant('EQUIPMENTS'), icon: 'meter' },
        { label: this._translateService.instant('CONFIRMATION'), icon: 'file-check' }
    ];
    currentFormStep = 0; //Current Step in form

    // ------------------------------------------------------------------
    // helpers for parish dropdowns to simplify template expressions
    // ------------------------------------------------------------------
    /**
     * Return the list of parish options for the currently selected equipment.
     * Always returns an array (never undefined).
     */
    get currentParishOptions(): ISSelectOption[] {
        if (this.selectedEquipmentIndex == null) {
            return [];
        }
        return this.parishOptions[this.selectedEquipmentIndex] || [];
    }

    /**
     * Indicates whether the select component should be shown instead of a plain
     * input.  The field must have a selected equipment and at least one option.
     */
    get showParishSelect(): boolean {
        return !!this.selectedEquipmentFormGroup && this.currentParishOptions.length > 0;
    }
    //#endregion STEPPER -----------------------

    //#region INVOICE FILE ---------------------
    protected invoiceFetchStatus = { // Status to tell if file was fecthed and sucefully read by azure intelligence studio
        fetched: false,
        successful: false
    };
    protected invoiceFile: File | null = null; //Uploaded Invoice File
    protected isDragging = false;
    protected primaryInvoiceForm: FormGroup<InvoiceDataFormGroup> | null = null;
    //#endregion INVOICE FILE ------------------

    constructor(
        private _userService: UsersService,
        private _entityService: EntitiesService,
        private _groupingService: GroupingsService,
        private _energyMetersService: EnergyMetersService,
        private _opportunityService: OpportunitiesService,
        private _addressService: AddressesService,
        private _snackbarService: SnackBarService,
        private _invoiceProcessorService: InvoiceProcessorService,
        private _translateService: TranslateService,
        private _dialogRef: MatDialogRef<NewOpportunityFormComponent>,
        private _contractsService: ContractsService,
        private _cdref: ChangeDetectorRef,
        private _fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) private _dialogData: any
    ) {
        this.countryCode = _userService.userCountryCode.toUpperCase(); //Set country code
        this.contractTypes = contractTypes.map((type) => //Map contract types to ISSelectOption
        {
            let contractTypeId = '';
            
            if(type.id == 'Personal'){
                contractTypeId = environment.contractTypeIds.Personal;
            }
            else{
                contractTypeId = environment.contractTypeIds.Business;
            }
            return new ISSelectOption(
                contractTypeId,
                this._translateService.instant(type.invariantCultureDescription.toUpperCase()),
                type.icon
            )
        });

        this._energyMetersService.getCountingCycles().pipe(takeUntil(this._destroy$)).subscribe({
            next: (sr) => {
                this.countTypesDatasource$.value.body = sr.data;
            }
        } )

        if(this._dialogData.opportunityId){
            _opportunityService.getOpportunity(this._dialogData.opportunityId).pipe(takeUntil(this._destroy$)).subscribe((opportunity: any) => {

                if(opportunity.data) {
                    this._newFormControls.contractType.setValue(opportunity.data.contractTypeId);
                    this._newFormControls.loyaltyPeriod.setValue(opportunity.data.preferentialLoyaltyPeriodMonths);
                    this._newFormControls.expectedStartDate.setValue(opportunity.data.date);
                    this._newFormControls.name.setValue(opportunity.data.entityName);
                    this._newFormControls.opportunityId.setValue(opportunity.data.id);
                    
                    this._opportunityService.getOpportunityElectricityMeters(this._dialogData.opportunityId).pipe(takeUntil(this._destroy$)).subscribe((electricityMeters: any) => {
                        if(electricityMeters.data.length > 0) {
                            for(let i = 0; i < electricityMeters.data.length; i++) {
                                this.addEquipment(electricityMeters.data[i].electricityMeterCode, null, true, electricityMeters.data[i]);
                                
                            }
                        }
                    });
                    
                    this._opportunityService.getOpportunityNaturalGasMeters(this._dialogData.opportunityId).pipe(takeUntil(this._destroy$)).subscribe((naturalGasMeters: any) => {
                        if(naturalGasMeters.data.length > 0) {
                            for(let i = 0; i < naturalGasMeters.data.length; i++) { 
                                this.addEquipment(naturalGasMeters.data[i].naturalGasMeterCode, null, true, naturalGasMeters.data[i]);
                                if(naturalGasMeters.data[i].naturalGasMeterTier){
                                    //TODO - NÃO PODE FICAR ASSIM
                                    // this.selectedEquipmentFormGroup?.controls.district.setValue(naturalGasMeters.data[i].);
                                    this.tier = naturalGasMeters.data[i].naturalGasMeterTier;
                                }
                                else if(naturalGasMeters.data[i].naturalGasMeterTariffOption) {
                                    //TODO - NÃO PODE FICAR ASSIM
                                    this.tariffOption = naturalGasMeters.data[i].naturalGasMeterTariffOption;
                                }
                            }
                        }
                    });
                }
            });
        }
    }

    /**
     * OnInit lifecycle hook. This method is called when the component is initialized.
     * It fetches the data based on the opportunity id.
     * @returns {void}
     */
    ngOnInit(): void {
        this.getOwnEntity();
    }

    /**
     * ngAfterContentInit lifecycle hook. This method is called after the content is initialized.
     * It sets up the form subscriptions and fetches the grouping data if available.
     * @returns {void}
     */
    ngAfterContentInit(): void {
        this.formSubscriptions();

        //Set Grouping
        if (!String.isNullOrUndefinedOrWhitespace(this._dialogData.groupingId)) {
            this._newFormControls.groupingId.setValue(this._dialogData.groupingId);
            this._newFormControls.groupingId.disable();

            let groupingsAPI = new MVListingConfigs(
                [
                    new MVFilter('Id', this._newFormControls.groupingId.value!, FilterOptionsType.text, FilterOperator.equals)
                ],
                null,
                new MVPagination(0, 999)
            )

            this._groupingService.getGroupings(groupingsAPI).pipe(takeUntil(this._destroy$)).subscribe((sr: ServerResponse<IGrouping[]>) => {
                if (sr.data && sr.data.length == 1) {
                    let grouping = sr.data[0];
                    this.selectedGroupingForElectricity = grouping.forElectricity;
                    this.selectedGroupingForNaturalGas = grouping.forNaturalGas;
                    this._newFormControls.groupingName.setValue(grouping.internalCode ?? null);
                    this._newFormControls.groupingName.disable();
                }
            });
        }

        // Only notify after the user has interacted with the form.
        // Programmatic initialisation typically keeps the form pristine, so we filter on dirty.
        this.subscriptions.push(
            this.newOpportunityForm.valueChanges.pipe(
                debounceTime(300),
                distinctUntilChanged((a, b) => _.isEqual(a, b)),
                filter(() => this.newOpportunityForm.dirty) // ignore initial programmatic sets
            ).subscribe(() => {
                if(!this.hasChanges)
                    this.hasChanges = true;
                // this._snackbarService.callSnackBar('FORM_CHANGED', SnackBarType.WARNING);
            })
        );
    }

    /**
     * ngOnDestroy lifecycle hook. This method is called when the component is destroyed.
     * It unsubscribes from all subscriptions to prevent memory leaks.
     * @returns {void}
     */
    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
        this.subscriptions.forEach(sub => {
            sub.unsubscribe();
        });
    }

    /**
     * Fetches the entity data based on the TIN of the current user.
     * If the TIN is not available, it sets the entity data to the user's name.
     * @returns {Promise<void>}
     */
    private async getOwnEntity(): Promise<void> {
        if (this._userData.tin) {
            this.ownEntity = await this.getEntityByTin(Number(this._userData.tin));
            if (this.ownEntity.permissions && !this.ownEntity.permissions?.exists) {
                this.ownEntity.permissions.tin = this._userData.tin;
                this.ownEntity.permissions.name = `${this._userData.firstName} ${this._userData.lastName}`.trim();
            }
        }
    }

    /**
 * Form subscriptions to handle changes in the form controls.
 * @returns {void}
 */
    private formSubscriptions(): void {
        //It is filled with data from SIGA. If the entity does not have data on SIGA, then it should not load anything.

        const entityControls = this._newFormControls.entity.controls;

        // #region IS OWN TIN
        this.subscriptions.push(
            this._newFormControls.isOwnTin.valueChanges.subscribe((isOwnTin: boolean | null) => {
                const entityControls = this._newFormControls.entity.controls;
                const entity = isOwnTin ? this.ownEntity : this.otherEntity;
                const hasInvoice = this.invoiceFetchStatus.fetched && this.invoiceFetchStatus.successful;

                // Set Entity ID
                entityControls.id.setValue(!String.isNullOrUndefinedOrWhitespace(entity.id) ? entity.id : null);

                // Handle TIN
                const tin = parseInt(entity.permissions?.tin ?? '', 10);
                if (!isNaN(tin)) {
                    entityControls.tin.setValue(tin);

                    // TIN is always disabled if has invoice OR isOwnTin
                    if (hasInvoice || isOwnTin) {
                        entityControls.tin.disable();
                    } else {
                        entityControls.tin.enable(); // allow changing tin manually
                    }
                } else {
                    entityControls.tin.setValue(null);
                    entityControls.tin.enable(); // allow input when no valid TIN
                }
            })
        );

        // #endregion

        // #region TIN
        this.subscriptions.push(
            entityControls.tin.valueChanges.pipe(distinctUntilChanged()).subscribe((tin: number | null) => {
                
                this._userService.getCurrentUser(localStorage.getItem('lang')!).pipe(takeUntil(this._destroy$)).subscribe(async (localUser: any) => {
                    // this._userService.userData = localUser;
                   
                    if (this._isTINValid(tin, this._userData.countryCode)) {
                        this._setContractTypeFromTin(tin!);
                    }

                    // let contractTypeId = this.contractTypes.find(x => x.label == this._newFormControls?.contractType?.value)?.value;

                    const isOwnTin = this._newFormControls.isOwnTin.value;
                    const contractTypeId = this._newFormControls.contractType.value;
                    const contractType = contractTypes.find(c => c.id === contractTypeId);
                    const hasInvoice = this.invoiceFetchStatus.fetched && this.invoiceFetchStatus.successful;

                    //Function that sets a value and disable if formControl has value
                    const setAndDisableEntityControls = (
                        controlGroup: { finalValue?: AbstractControl; serverValue?: AbstractControl },
                        value: any
                    ): void => {
                        controlGroup.finalValue?.setValue(null);
                        controlGroup.finalValue?.enable();
                        controlGroup.serverValue?.setValue(null);

                        if (value != null) {
                            controlGroup.finalValue?.setValue(value);
                            controlGroup.finalValue?.disable();
                            controlGroup.serverValue?.setValue(value);
                        }
                    };

                    //Function that clears and disables controls (Used when TIN is invalid and we disable other inputs until there is a valid tin)
                    const clearAndDisableEntityControls = (
                        controlGroup: { finalValue?: AbstractControl; serverValue?: AbstractControl }
                    ): void => {
                        controlGroup.finalValue?.setValue(null);
                        controlGroup.serverValue?.setValue(null);
                        controlGroup.finalValue?.disable();
                    };

                    //Function to update entity controls with fetch data
                    const updateEntityControls = (entityData: ResolvedEntity): void => {
                        const { permissions, entity } = entityData;

                        // Handle Name from permissions
                        if (permissions?.name) {
                            entityControls.name.setValue(permissions.name);
                            entityControls.name.disable();
                        }

                        if (!entity) return;

                        // Phone Number and Email
                        setAndDisableEntityControls(entityControls.phoneNumber?.controls ?? {}, entity.cellPhoneNumber);
                        setAndDisableEntityControls(entityControls.email?.controls ?? {}, entity.email);

                        const address = entity.address;
                        if (!address) return;

                        // Address fields
                        setAndDisableEntityControls(entityControls.address?.controls ?? {}, address.street);
                        setAndDisableEntityControls(entityControls.postalCode?.controls ?? {}, address.postalCode);
                        setAndDisableEntityControls(entityControls.parish?.controls ?? {}, address.parish);

                        // Set IDs (not disabled)
                        entityControls.postalCode?.controls?.finalId?.setValue(address.postalCodeId ?? null);
                        entityControls.parish?.controls?.finalId?.setValue(address.parishId ?? null);
                    };

                    //Validate is TIN is valid
                    if (!this._isTINValid(tin, this._userData.countryCode)) {
                        //If isnt valid we disable and clear all inputs
                        entityControls.name.reset();
                        entityControls.name.disable();
                        clearAndDisableEntityControls(entityControls.phoneNumber?.controls ?? {});
                        clearAndDisableEntityControls(entityControls.address?.controls ?? {});
                        clearAndDisableEntityControls(entityControls.postalCode?.controls ?? {});
                        clearAndDisableEntityControls(entityControls.parish?.controls ?? {});
                        clearAndDisableEntityControls(entityControls.email?.controls ?? {});
                        this._newFormControls.contractType.setValue(null);
                        return;
                    }

                    const tinStr = tin!.toString();

                    // Warn if contract type is Personal and TIN is not valid for external lookup
                    const firstDigit = parseInt(tinStr[0], 10);

                    if (!isOwnTin && contractType?.invariantCultureDescription === 'Personal' && ![5, 6, 8, 9].includes(firstDigit) && !hasInvoice) {
                        this._snackbarService.callSnackBar('TIN_PERSONAL_NOT_ALLOWED', SnackBarType.WARNING);
                        return;
                    }

                    if (isOwnTin) {
                        updateEntityControls(this.ownEntity);
                        return;
                    }

                    // TIN de terceiros
                    const cachedEntity = this.fetchedEntities.find(e => e.permissions?.tin === tinStr);

                    if (cachedEntity && cachedEntity.permissions?.exists) {

                        this.otherEntity = cachedEntity;

                        if (cachedEntity.permissions.exists) {
                            updateEntityControls(cachedEntity);
                        } else {
                            entityControls.name.enable();
                            entityControls.phoneNumber.controls.finalValue.enable();
                            entityControls.email.controls.finalValue.enable();
                            entityControls.address.controls.finalValue.enable();
                            entityControls.postalCode.controls.finalValue.enable();
                            entityControls.parish.controls.finalValue.enable();
                        }
                        return;
                    }

                    try {
                        this.isFetchingEntity = true;
                        const fetchedEntity = await this.getEntityByTin(tin!);
                        this.otherEntity = fetchedEntity;

                        if (fetchedEntity.permissions?.exists) {
                            updateEntityControls(fetchedEntity);
                        } else {
                            entityControls.name.enable();
                            entityControls.phoneNumber.controls.finalValue.enable();
                            entityControls.email.controls.finalValue.enable();
                            entityControls.address.controls.finalValue.enable();
                            entityControls.postalCode.controls.finalValue.enable();
                            entityControls.parish.controls.finalValue.enable();
                        }

                    } catch (error) {
                        this._snackbarService.callSnackBar('ERROR_OCURRED', SnackBarType.ERROR);
                    } finally {
                        this.isFetchingEntity = false;
                    }
                });
            })
        );
        // #endregion
    }


    /**
     * Fetch the entity data by TIN.
     * @param tin TIN to search
     * @returns {Promise<ResolvedEntity>} Entity object
     */
    private async getEntityByTin(tin: number): Promise<ResolvedEntity> {
        const entity: ResolvedEntity = { id: null, entity: null, permissions: null };

        const srPermisisons = await firstValueFrom(
            this._entityService.getEntityByTin(tin.toString(), undefined, true)
        );

        srPermisisons.data.tin = tin.toString();
        entity.id = srPermisisons.data.id;
        entity.permissions = srPermisisons.data;

        if (srPermisisons.data.exists) {
            const srEntity = await firstValueFrom(this._entityService.getEntity(srPermisisons.data.id, true));
            entity.entity = srEntity.data;
        }

        this.fetchedEntities.push(entity);
        return entity;
    }

    //#region ADD EQUIPMENT
    private adaptInvoiceProcessorEquipments(equipments: ISLibEnergyMeter[]): EnergyMeter[] {
        const createComparisonGroup = (source?: FormGroup<any>): FormGroup<any> => {
            const value = source?.getRawValue() ?? {};

            return new FormGroup({
                invoiceValue: new FormControl(value.invoiceValue ?? null),
                serverValue: new FormControl(value.serverValue ?? null),
                finalValue: new FormControl(value.finalValue ?? null),
                invoiceId: new FormControl(value.invoiceId ?? null),
                serverId: new FormControl(value.serverId ?? null),
                finalId: new FormControl(value.finalId ?? null),
                comparisonResult: new FormControl(value.comparisonResult ?? null)
            });
        };

        return equipments.map((equipment) => {
            const formGroup = equipment as FormGroup<any>;

            if (formGroup.get('tensionLevel')) {
                const contractedPower = formGroup.get('contractedPower') as FormGroup<any>;
                const extraControls = [
                    'contractedPowerP1',
                    'contractedPowerP2',
                    'contractedPowerP3',
                    'contractedPowerP4',
                    'contractedPowerP5',
                    'contractedPowerP6'
                ];

                extraControls.forEach((controlName) => {
                    if (!formGroup.contains(controlName)) {
                        formGroup.addControl(controlName, createComparisonGroup(contractedPower));
                    }
                });

                if (!formGroup.contains('electricityTariff')) {
                    formGroup.addControl('electricityTariff', createComparisonGroup());
                }
            }

            return formGroup as EnergyMeter;
        });
    }

    /**
     * Adds a new electricity equipment to the form array.
     * @param equipmentCode The code of the electricity equipment.
     * @param invoice The invoice data form group.
     * @returns {void}
     */
    private addEquipment(
        equipmentCode: string | null,
        invoiceFile: File | null,
        assignedToEnergyOpportunity: boolean = false,
        equipmentData: any = undefined,
        primaryInvoice: boolean = false
    ): void {

        let elecFormGroup!: FormGroup<ElectricityEquipmentFormGroup>;
        let gasFormGroup!: FormGroup<NaturalGasEquipmentFormGroup>;
        const invoiceProcessorApiUrl = environment.apiUrl.replace(/\/+$/, '');

        const assignEquipmentsToForm = (equipments: EnergyMeter[]) => {
            equipments.forEach(equipment => {
                if (this.formGroupIsElectricity(equipment.controls)) {

                    if (!equipment.controls.equipmentCode.controls.finalValue.value) {
                        equipment.controls.equipmentCode.controls.serverValue.setValue(equipmentCode);
                        equipment.controls.equipmentCode.controls.finalValue.setValue(equipmentCode);
                    }

                    if (equipment.controls.countType.controls.finalId?.value) {
                        let countTypeId = equipment.controls.countType.controls.finalId?.value
                        let countTypeInvariantDescription = this.countTypesDatasource$.value.body?.find( (countType) => countType.id == countTypeId )?.description
                        equipment.controls.countType.controls.serverValue.setValue(countTypeInvariantDescription);
                        equipment.controls.countType.controls.finalValue.setValue(countTypeInvariantDescription);
                    }

                    // add equipment to form array and keep track of its index
                    this.newOpportunityForm.controls.electricityEquipments.push(equipment as FormGroup<ElectricityEquipmentFormGroup>);
                    const currentIndex = this._equipmentFormArrayControls.length - 1;
                    // ensure we have a slot for parish options for this equipment
                    this.parishOptions[currentIndex] = [];

                    // this.selectEquipment(currentIndex); // Select the newly added equipment
                    elecFormGroup = equipment as FormGroup<ElectricityEquipmentFormGroup>;

                    if (elecFormGroup) {
                        const postalCodeControl = elecFormGroup.controls.postalCode.controls.finalValue as FormControl<string | null>;
                        const tensionLevelControl = elecFormGroup.controls.tensionLevel as FormGroup<DataComparisonFormGroup<string | null>>;
                        const electricityTariffControl = elecFormGroup.controls.electricityTariff as FormGroup<DataComparisonFormGroup<string | null>>;

                        this.subscriptions.push(
                            postalCodeControl.valueChanges.subscribe((postalCode: string | null) => {
                                fetchZipCode(postalCode, postalCodeControl, currentIndex);
                            }),
                            tensionLevelControl.valueChanges.subscribe(( tensionLevelValue: any ) => {
                                if (this.countryCode == 'PT') {

                                } else {
                                    if (!String.isNullOrUndefinedOrWhitespace(tensionLevelValue.finalId)) {                                        
                                        elecFormGroup.controls.electricityTariff.reset();
                                        elecFormGroup.controls.electricityTariff.enable();
                                        this.electricityTariffDatasource$.value.apiUrl = `${environment.apiUrl}Electricity/${this._userService.userCountryCode}/TensionLevels/${tensionLevelValue.finalId}/Tariffs`;
                                    } else {
                                        elecFormGroup.controls.electricityTariff.reset();
                                        elecFormGroup.controls.electricityTariff.disable();
                                    }
                                    
                                    this.electricityTariffDatasource$.value.body = [];
                                }
                            }),
                            electricityTariffControl.valueChanges.subscribe((tariffValue: any) => {
                                if (!String.isNullOrUndefinedOrWhitespace(tariffValue.finalId)) {                                   
                                    elecFormGroup.controls.contractedPowerP1.enable();
                                    elecFormGroup.controls.contractedPowerP2.enable();
                                    
                                    if (!tariffValue.finalValue.startsWith('2')) {
                                        elecFormGroup.controls.contractedPowerP3.enable();
                                        elecFormGroup.controls.contractedPowerP4.enable();
                                        elecFormGroup.controls.contractedPowerP5.enable();
                                        elecFormGroup.controls.contractedPowerP6.enable();
                                    } else {
                                        elecFormGroup.controls.contractedPowerP3.disable();
                                        elecFormGroup.controls.contractedPowerP4.disable();
                                        elecFormGroup.controls.contractedPowerP5.disable();
                                        elecFormGroup.controls.contractedPowerP6.disable();
                                    }

                                } else {
                                    elecFormGroup.controls.contractedPowerP1.disable();
                                    elecFormGroup.controls.contractedPowerP2.disable();
                                    elecFormGroup.controls.contractedPowerP3.disable();
                                    elecFormGroup.controls.contractedPowerP4.disable();
                                    elecFormGroup.controls.contractedPowerP5.disable();
                                    elecFormGroup.controls.contractedPowerP6.disable();
                                }
                            })
                        );
                        if (equipmentData) {
                            elecFormGroup.controls.peakEnergyPrice.setValue(equipmentData.peakEnergyPrice);
                            elecFormGroup.controls.offPeakEnergyPrice.setValue(equipmentData.offPeakEnergyPrice);
                            elecFormGroup.controls.standardEnergyPrice.setValue(equipmentData.standardEnergyPrice);
                            elecFormGroup.controls.superOffPeakEnergyPrice.setValue(equipmentData.superOffPeakEnergyPrice);
                        }

                        this.equipmentSelectedTabs.push(0);
                    }
                } else if (this.formGroupIsNaturalGas(equipment.controls)) {

                    if (!equipment.controls.equipmentCode.controls.finalValue.value) {
                        equipment.controls.equipmentCode.controls.serverValue.setValue(equipmentCode);
                        equipment.controls.equipmentCode.controls.finalValue.setValue(equipmentCode);
                    }

                    this.newOpportunityForm.controls.naturalGasEquipments.push(equipment as FormGroup<NaturalGasEquipmentFormGroup>);
                    const currentIndex = this._equipmentFormArrayControls.length - 1;
                    this.parishOptions[currentIndex] = [];

                    // this.selectEquipment(currentIndex); // Select the newly added equipment
                    gasFormGroup = equipment as FormGroup<NaturalGasEquipmentFormGroup>;

                    if (gasFormGroup) {
                        const postalCodeControl = gasFormGroup.controls.postalCode as FormGroup<DataComparisonFormGroup<string | null, any>>;
                        
                        this.subscriptions.push(
                            postalCodeControl.valueChanges.subscribe((postalCode: any) => {
                                fetchZipCode(postalCode.finalValue, postalCodeControl.controls.finalValue, currentIndex);
                            })
                        );

                        const pressureLevelControl = gasFormGroup.controls.pressureLevel as FormGroup<DataComparisonFormGroup<string | null, any>>;
                        this.subscriptions.push(
                            pressureLevelControl.valueChanges.subscribe((value: any) => {
                                if(value.finalId){
                                    let sourceToLook = this.pressureLevelDatasource$.value.body;
                                    this.pressureLevel = sourceToLook?.find(x => x.id == value.finalId)?.description;
                                    gasFormGroup.controls.tier.value.finalId = null;
                                    gasFormGroup.controls.tariffOption.value.finalId = null;
                                }
                                else{
                                    this.pressureLevel = '';
                                    // gasFormGroup.controls.tier.value.finalId = null;
                                    // gasFormGroup.controls.tariffOption.value.finalId = null;
                                    gasFormGroup.controls.tariffOption.patchValue({
                                        finalId: null,
                                        finalValue: null,
                                        invoiceId: null,
                                        invoiceValue: null,
                                        serverValue: null,
                                        comparisonResult: null
                                    });
                                    gasFormGroup.controls.tier.patchValue({
                                        finalId: null,
                                        finalValue: null,
                                        invoiceId: null,
                                        invoiceValue: null,
                                        serverValue: null,
                                        comparisonResult: null
                                    });
                                }
                            })
                        );

                        const tierControl = gasFormGroup.controls.tier as FormGroup<DataComparisonFormGroup<string | null, any>>;
                        this.subscriptions.push(
                            tierControl.valueChanges.subscribe((value: any) => {
                                if(value.finalId){
                                    let sourceToLook = this.tierDatasource$.value.body;
                                    this.tier = sourceToLook?.find(x => x.id == value.finalId).description;
                                }
                                else
                                    this.tier = '';
                            })
                        );

                        const tariffControl = gasFormGroup.controls.tariffOption as FormGroup<DataComparisonFormGroup<string | null, any>>;
                        this.subscriptions.push(
                            tariffControl.valueChanges.subscribe((value: any) => {
                                if(value.finalId){
                                    let sourceToLook = this.tariffOptionDatasource$.value.body;
                                    this.tariffOption = sourceToLook?.find(x => x.id == value.finalId).description;
                                }
                                else
                                    this.tariffOption = '';
                            })
                        );

                        // postalCodeControl.setValue(gasFormGroup.controls.postalCode.value);
                        this.equipmentSelectedTabs.push(0);
                    }
                }

                equipment.controls.associatedWithOpportunity.setValue(assignedToEnergyOpportunity)
            });
        }

        if (!String.isNullOrUndefinedOrWhitespace(equipmentCode)) {
            //Clean code (blank spaces, commas, ...) and find duplicates
            const clean = (val: string | null): string | null => val?.trim().replace(/\s+/g, '') || null;
            const cleanedCode = clean(equipmentCode);
            if (!String.isNullOrUndefinedOrWhitespace(cleanedCode)) {
                if (!this.codeAlreadyExists(cleanedCode)) {
                    this._invoiceProcessorService.getMeterByCode(cleanedCode, true, invoiceProcessorApiUrl).pipe(takeUntil(this._destroy$)).subscribe(equipments => {
                        assignEquipmentsToForm(this.adaptInvoiceProcessorEquipments(equipments));
                    });
                } else {
                    this.addEquipmentGroup.controls.equipmentCode.setErrors({'duplicateCode': true})
                    return
                }
                
            } else return;

        } else if (invoiceFile) {
            this._invoiceProcessorService.getMeterByFile(invoiceFile, false, invoiceProcessorApiUrl).pipe(takeUntil(this._destroy$)).subscribe({
                next: (result: InvoiceProcessorResult) => {
                    result.invoice.controls.isPrimaryInvoice.setValue(primaryInvoice);
                    this.primaryInvoiceForm = (result.invoice as any) as FormGroup<InvoiceDataFormGroup>;
                    this.invoiceFetchStatus.fetched = true;
                    this.invoiceFetchStatus.successful = true;

                    const invoiceEntity = result.entity?.getRawValue();
                    this.otherEntity = {
                        id: invoiceEntity?.id ?? null,
                        entity: null,
                        permissions: {
                            exists: result.entity !== null,
                            haveActiveContracts: false,
                            id: invoiceEntity?.id ?? '',
                            name: invoiceEntity?.name ?? result.invoice.controls.customerName.value ?? '',
                            tin: result.invoice.controls.customerTin.value ?? ''
                        }
                    };

                    assignEquipmentsToForm(this.adaptInvoiceProcessorEquipments(result.equipments));
                },
                error: () => {
                    this.invoiceFile = null;
                    this.invoiceFetchStatus.fetched = false;
                    this.invoiceFetchStatus.successful = false;
                    this._snackbarService.callSnackBar('ERROR_OCURRED', SnackBarType.ERROR);
                }
            });
        }

        // updated to associate parish options with a specific equipment index
        const fetchZipCode = (zipCode: string | null, formControl: FormControl<string | null>, idx: number)  => {
            if (zipCode && this._zipCodeRegexpPattern().test(zipCode)) {
                (this.countryCode == 'PT' ? this._addressService.getPostalCodePT(zipCode) : this._addressService.getPostalCodeES(zipCode)).pipe(takeUntil(this._destroy$)).subscribe((sr: ServerResponse<any>) => {
                    if (sr.data) {
                        const equipmentFormGroup = this._equipmentFormArrayControls[idx] as FormGroup<any>;
                        equipmentFormGroup.controls['postalCodeId'].setValue(sr.data.id);

                        equipmentFormGroup.setControl('county', this.buildComparisonGroup(null, sr.data.county));
                        equipmentFormGroup.setControl('district', this.buildComparisonGroup(null, sr.data.district));
                        equipmentFormGroup.setControl('locality', this.buildComparisonGroup(null, sr.data.locality));

                        equipmentFormGroup.get('county.finalValue')?.disable();
                        equipmentFormGroup.get('district.finalValue')?.disable();
                        equipmentFormGroup.get('locality.finalValue')?.disable();

                        this._addressService.getParishes(sr.data.fkCounty).pipe(takeUntil(this._destroy$)).subscribe((parishes: ServerResponse<any[]>) => {
                            if (parishes.data?.length) {
                                this.parishOptions[idx] = parishes.data.map( (parish) => new ISSelectOption(parish.id, parish.name));
                                this._cdref.detectChanges();
                            }
                        });
                    } else {
                        //Zip code not found
                        //Must forbid user to continue with this equipment
                        formControl.setErrors({ notFound: true });
                    }
                });
            }
        }
        
        this.cancelAddEquipment(); // Reset the add equipment interface
    }
    //#endregion

    //#region SUBMIT FORM

    /**
     * Submits the entire opportunity flow, including entity creation,
     * electricity/gas equipment creation, and opportunity association.
     */
    protected submitOpportunity(): void {
        const entityControl = this.newOpportunityForm.controls.entity;
        let hasconsumptions: boolean = false;

        const finalizeSubmission = () => {
            const opportunityIdControl = this.newOpportunityForm.controls.opportunityId;

            if (!opportunityIdControl.value) {
                const opportunityToCreate: CreateOpportunity = {
                    entityId: entityControl.controls.id.value ?? undefined,
                    //originEntityId: entityControl.value,
                    businessTypeId: 1,
                    date: this.newOpportunityForm.controls.expectedStartDate.value!,
                    contactOriginTypeId: environment.opportunityContactOrigin,
                    preferentialLoyaltyPeriodMonths: this.newOpportunityForm.controls.loyaltyPeriod.value ?? undefined
                };

                // Checks if it has electricity consumptions filled. If not, does not submit.
                if (this.newOpportunityForm.controls.electricityEquipments.controls.length > 0) {
                    for (let i = 0; i < this.newOpportunityForm.controls.electricityEquipments.length; i++) {
                        const equipmentValue = this.newOpportunityForm.controls.electricityEquipments.controls[i].controls;
                        const consumptions = equipmentValue?.consumptions.value ?? [];

                        for (let j = 0; j < consumptions.length; j++) {
                            const consumption = consumptions[j] ?? {};
                            if (consumption.offPeak || consumption.peak || consumption.standard || consumption.superOffPeak) {
                                this.consumptionsDictionary.set(j, true);
                                // hasConsumptions = true;
                            } else {
                                this.consumptionsDictionary.set(j, false);
                            }
                        }
                    }
                }

                // Checks if it has natural gas consumptions filled. If not, does not submit.
                if (this.newOpportunityForm.controls.naturalGasEquipments.controls.length > 0) {
                    for (let i = 0; i < this.newOpportunityForm.controls.naturalGasEquipments.controls.length; i++) {
                        const equipmentValue = this.newOpportunityForm.controls.naturalGasEquipments.controls[i].controls;
                        const consumptions = equipmentValue?.consumptions.value ?? [];

                        for (let j = 0; j < consumptions.length; j++) {
                            const consumption = consumptions[j] ?? {};
                            if (consumption.offPeak || consumption.peak || consumption.standard || consumption.superOffPeak) {
                                this.consumptionsDictionary.set(j, true);
                                // hasConsumptions = true;
                            } else {
                                this.consumptionsDictionary.set(j, false);
                            }
                        }
                    }
                }

                // Validates if all the consumptions are filled
                let consumptionCounter = 0;

                for(let [key, value] of this.consumptionsDictionary){
                    if(value == true){
                        consumptionCounter++;
                        hasconsumptions = true;
                    }
                }

                // Only submits if all consumptions are filled, else shows warning to the user
                if(hasconsumptions && consumptionCounter == this.consumptionsDictionary.size && this.hasChanges){
                    this._opportunityService.createEnergyOpportunity(opportunityToCreate).subscribe((sr: ServerResponse<any>) => {
                        if (sr.data) {
                            opportunityIdControl.setValue(sr.data.id);
                            this.submitOpportunity();
                            this.hasChanges = false;
                        }
                    });
                }
                else{
                    this._snackbarService.callSnackBar('FILL_CONSUMPTIONS', SnackBarType.WARNING);
                    return;
                }                
            } else {
                this.associateEnergyMetersToOpportunity(opportunityIdControl.value);
            }
        };

        const submitEntityIfNeeded = (): Observable<any> => {
            if (entityControl.controls.id.value) return of(entityControl.controls.id.value);

            const entity: CreateEntity = {
                name: entityControl.controls.name.value!,
                tin: entityControl.controls.tin.value!
            };

            return this._entityService.postEntity(entity, false).pipe(
                tap((sr) => {
                    if (sr.data) entityControl.controls.id.setValue(sr.data);
                })
            );
        };

        const submitEquipments = (): Observable<void> => {
            const electricity = this._newElectricityEquipmentFormArrayControls.filter(fg => !fg.controls.equipmentId.value);
            const gas = this._newNaturalGasEquipmentFormArrayControls.filter(fg => !fg.controls.equipmentId.value);

            const requests: Observable<any>[] = [];

            if (electricity.length > 0) {
                let payloads: CreateElectricityMeterPT[] | CreateElectricityMeterES[] = [];
                
                if (this.countryCode == 'PT') {
                    payloads = electricity.map((fg) => ({
                        code: fg.controls.equipmentCode.controls.finalValue.value!,
                        contractedPower: fg.controls.contractedPower.controls.finalValue.value!,
                        countTypeId: fg.controls.countType.controls.finalId?.value!,
                        isISPFree: false,
                        tensionLevelId: fg.controls.tensionLevel.controls.finalId?.value!,
                        timeCycleId: fg.controls.timeCycle.controls.finalId?.value!,
                        address: {
                            country: this._userData.countryId,
                            postalCode: fg.controls.postalCode.controls.finalValue.value!,
                            postalCodeId: fg.controls.postalCodeId.value!,
                            parishId: +(fg.controls.parish.controls.finalValue.value ?? fg.controls.parish.controls.finalId?.value),
                            street: fg.controls.street.controls.finalValue.value!,
                            floorFraction: fg.controls.floor.controls.finalValue.value!,
                            doorNumber: fg.controls.door.controls.finalValue.value!
                        }
                    }));
                } else {
                    payloads = electricity.map((fg) => ({
                        code: fg.controls.equipmentCode.controls.finalValue.value!,

                        contractedPowerP1: fg.controls.contractedPowerP1.controls.finalValue.value!,
                        contractedPowerP2: fg.controls.contractedPowerP2.controls.finalValue.value!,
                        contractedPowerP3: fg.controls.contractedPowerP3.controls.finalValue.value!,
                        contractedPowerP4: fg.controls.contractedPowerP4.controls.finalValue.value!,
                        contractedPowerP5: fg.controls.contractedPowerP5.controls.finalValue.value!,
                        contractedPowerP6: fg.controls.contractedPowerP6.controls.finalValue.value!,

                        tariffId: fg.controls.electricityTariff.controls.finalId?.value!,
                        address: {
                            country: this._userData.countryId,
                            postalCode: fg.controls.postalCode.controls.finalValue.value!,
                            postalCodeId: fg.controls.postalCodeId.value!,
                            parishId: +(fg.controls.parish.controls.finalValue.value ?? fg.controls.parish.controls.finalId?.value),
                            street: fg.controls.street.controls.finalValue.value!,
                            floorFraction: fg.controls.floor.controls.finalValue.value!,
                            doorNumber: fg.controls.door.controls.finalValue.value!
                        }
                    }))
                }
                requests.push(
                    forkJoin(
                        payloads.map(m => this._energyMetersService.postElectricityMeter(m))
                    ).pipe(
                        tap((responses) => {
                            responses.forEach((res, idx) => {
                                if (res.data) electricity[idx].controls.equipmentId.setValue(res.data);
                            });
                        })
                    )
                );
            }

            if (gas.length > 0) {
                const payloads = gas.map((fg) => ({
                    // this.selectedEquipmentFormGroup.controls.tier.value.finalId == this.selectedEquipmentFormGroup.value.tier.finalId
                    code: fg.controls.equipmentCode.controls.finalValue.value!,
                    pressureLevelId: fg.controls.pressureLevel.controls.finalId?.value,
                    tariffOptionId: fg.controls.tariffOption.controls.finalId?.value,
                    tierId: fg.controls.tier.controls.finalId?.value,
                    isISPFree: false,
                    address: {
                        country: this._userData.countryId,
                        postalCode: fg.controls.postalCode.controls.finalValue.value!,
                        postalCodeId: fg.controls.postalCodeId.value!,
                        parishId: +fg.controls.parish.controls.finalId?.value,
                        street: fg.controls.street.controls.finalValue.value,
                        floorFraction: fg.controls.floor.controls.finalValue.value,
                        doorNumber: fg.controls.door.controls.finalValue.value
                    }
                }));

                requests.push(
                    forkJoin(
                        payloads.map(m => this._energyMetersService.postNaturalGasMeter(m))
                    ).pipe(
                        tap((responses) => {
                            responses.forEach((res, idx) => {
                                if (res.data) gas[idx].controls.equipmentId.setValue(res.data);
                            });
                        })
                    )
                );
            }

            return forkJoin(requests).pipe(map(() => void 0));
        };

        submitEntityIfNeeded().pipe(
            switchMap(() => submitEquipments())
        ).subscribe({
            complete: finalizeSubmission
        });
    }

    private associateEnergyMetersToOpportunity(opportunityId: string) {
        let electricityMetersToInsert: { electricityMeters: CreateEnergyOpportunityElectricityMeters[] } = {
            electricityMeters: []
        }
        let naturalGasMetersToInsert: { naturalGasMeters: CreateEnergyOpportunityNaturalGasMeters[] } = {
            naturalGasMeters: []
        }

        let electricity: FormGroup<ElectricityEquipmentFormGroup>[];
        let gas: FormGroup<NaturalGasEquipmentFormGroup>[];

        if(this._newElectricityEquipmentFormArrayControls.filter((x: FormGroup<ElectricityEquipmentFormGroup>) => x.controls.associatedWithOpportunity.value == null || x.controls.associatedWithOpportunity.value == false).length == 1){
            const elecItem = this._newElectricityEquipmentFormArrayControls.filter((x: FormGroup<ElectricityEquipmentFormGroup>) => x.controls.associatedWithOpportunity.value == null || x.controls.associatedWithOpportunity.value == false)[0];
            electricity = [elecItem];
        }
        else
            electricity = this._newElectricityEquipmentFormArrayControls.filter(fg => fg.controls.associatedWithOpportunity.value == false);

        if(this._newNaturalGasEquipmentFormArrayControls.filter((x: FormGroup<NaturalGasEquipmentFormGroup>) => x.controls.associatedWithOpportunity.value == null || x.controls.associatedWithOpportunity.value == false).length == 1){
            const gasItem = this._newNaturalGasEquipmentFormArrayControls.filter((x: FormGroup<NaturalGasEquipmentFormGroup>) => x.controls.associatedWithOpportunity.value == null || x.controls.associatedWithOpportunity.value == false)[0];
            gas = [gasItem];
        }
        else
            gas = this._newNaturalGasEquipmentFormArrayControls.filter(fg => fg.controls.associatedWithOpportunity.value == false);

        let observables: Observable<ServerResponse<any>>[] = [];

        electricity.forEach((fg: FormGroup<ElectricityEquipmentFormGroup>) => {
            let newCreateObject = new CreateEnergyOpportunityElectricityMeters(
                fg.controls.equipmentId.value!,
                fg.controls.consumptions.controls.at(-1)?.controls.date.value,
                0, fg.controls.offPeakEnergyPrice.value ?? 0, 0, fg.controls.peakEnergyPrice.value ?? 0, 0, fg.controls.standardEnergyPrice.value ?? 0, 0, fg.controls.superOffPeakEnergyPrice.value ?? 0)

            let electricityMeter = fg.controls.consumptions.controls.reduce<CreateEnergyOpportunityElectricityMeters>((obj, consumptionGroup) => {
                obj.offPeakEstimatedAnnualConsumption! += +(consumptionGroup.controls.offPeak.value ?? 0);
                obj.peakEstimatedAnnualConsumption! += +(consumptionGroup.controls.peak.value ?? 0);
                obj.standardEstimatedAnnualConsumption! += +(consumptionGroup.controls.standard.value ?? 0);
                obj.superOffPeakEstimatedAnnualConsumption! += +(consumptionGroup.controls.superOffPeak.value ?? 0);
                return obj;
            }, newCreateObject);

            electricityMeter.offPeakEnergyPrice! = +(fg.controls.offPeakEnergyPrice.value ?? 0);
            electricityMeter.peakEnergyPrice! = +(fg.controls.peakEnergyPrice.value ?? 0);
            electricityMeter.standardEnergyPrice! = +(fg.controls.standardEnergyPrice.value ?? 0);
            electricityMeter.superOffPeakEnergyPrice! = +(fg.controls.superOffPeakEnergyPrice.value ?? 0);

            electricityMetersToInsert.electricityMeters.push(electricityMeter);
        });

        gas.forEach((fg: FormGroup<NaturalGasEquipmentFormGroup>) => {
            let newCreateObject = new CreateEnergyOpportunityNaturalGasMeters(fg.controls.equipmentId.value!, 0, 0)

            let naturalGasMeter = fg.controls.consumptions.controls.reduce<CreateEnergyOpportunityNaturalGasMeters>((obj, consumptionGroup) => {
                obj.estimatedAnnualConsumption! += +(consumptionGroup.controls.gas.value ?? 0)
                return obj;
            }, newCreateObject);

            naturalGasMeter.energyPrice! = +(fg.controls.energyPrice.value ?? 0);


            naturalGasMetersToInsert.naturalGasMeters.push(naturalGasMeter);
        })

        forkJoin({
            electricity: this._opportunityService.associateElectricityMeterToEnergyOpportunity(electricityMetersToInsert, opportunityId),
            naturalGas: this._opportunityService.associateNaturalGasMeterToEnergyOpportunity(naturalGasMetersToInsert, opportunityId)
        }).subscribe((srs: { [key: string]: ServerResponse<any[]> }) => {
            let requests: Observable<ServerResponse<any>>[] = [];

            Object.entries(srs).forEach(([key, sr]) => {
                if (sr.data) {
                    if (key == 'electricity') {
                        requests.push(...this._newElectricityEquipmentFormArrayControls.map((fg: FormGroup<ElectricityEquipmentFormGroup>) => {
                            let consumptions: CreateElectricityMeterConsumption[] = fg.controls.consumptions.controls.filter(fg => fg.disabled == false).map((consumptionGroup: FormGroup<ConsumptionsFormGroup>) => {
                                return new CreateElectricityMeterConsumption(
                                    format(new Date(consumptionGroup.controls.date.value!), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
                                    +(consumptionGroup.controls.offPeak.value ?? 0),
                                    +(consumptionGroup.controls.peak.value ?? 0),
                                    +(consumptionGroup.controls.standard.value ?? 0),
                                    undefined,
                                    consumptionGroup.controls.superOffPeak.value != null ? +consumptionGroup.controls.superOffPeak.value : undefined
                                );
                            });

                            return this._energyMetersService.postElectricityMeterConsumptions(fg.controls.equipmentId.value!, consumptions)
                        }));

                        requests.push(...sr.data.map((energyOpportunity) => {
                            let electricityGrouping = new CreateElectricityGrouping(
                                [],
                                this.newOpportunityForm.controls.contractType.value!,
                                energyOpportunity.electricityMeterId,
                                energyOpportunity.id,
                                this.newOpportunityForm.controls.groupingId.value!
                            );

                            return this._groupingService.createElectricityGrouping(electricityGrouping)
                        }))
                    } else {
                        requests.push(...this._newNaturalGasEquipmentFormArrayControls.map((fg: FormGroup<NaturalGasEquipmentFormGroup>) => {
                            let consumptions: CreateNaturalGasMeterConsumption[] = fg.controls.consumptions.controls.filter(fg => fg.disabled == false).map((consumptionGroup: FormGroup<ConsumptionsFormGroup>) => {
                                return new CreateNaturalGasMeterConsumption(
                                    format(new Date(consumptionGroup.controls.date.value!), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
                                    +(consumptionGroup.controls.gas.value ?? 0)
                                );
                            });

                            return this._energyMetersService.postNaturalGasMeterConsumptions(fg.controls.equipmentId.value!, consumptions);
                        }));

                        requests.push(...sr.data.map((energyOpportunity) => {
                            let naturalGasGrouping = new CreateNaturalGasGrouping(
                                [],
                                // this.newOpportunityForm.controls.contractType.value!,
                                this.contractTypes.find(x => x.value == this.newOpportunityForm.controls.contractType.value!)?.value,
                                energyOpportunity.naturalGasMeterId,
                                energyOpportunity.id,
                                this.newOpportunityForm.controls.groupingId.value!
                            );

                            return this._groupingService.createNaturalGasGrouping(naturalGasGrouping)
                        }));
                    }
                }
            })

            forkJoin(requests).subscribe((srs: ServerResponse<any>[]) => {
                if (srs.every((sr) => sr.data)) {
                    this._snackbarService.callSnackBar('EQUIPMENT_GROUP_CREATED_SUCCESSFULLY', SnackBarType.SUCCESS);
                    this._dialogRef.close(this._newFormControls.opportunityId.value);
                }
            })
        });


    }
    //#endregion

    //#region Handle File
    /**
     * Faz o upload do ficheiro da fatura
     * @param file Ficheiro
     * @param primaryInvoice Indicador se é a fatura principal a ser enviada
     * @returns {void}
     */
    private uploadInvoice(file: File, primaryInvoice: boolean): void {
        this.addEquipment(null, file, false, undefined, primaryInvoice);
    }

    /**
     * Envia o ficheiro para o Document Intelligence do Azure para análise e receber os dados da entidade e dos equipamentos
     * @param fileData Ficheiros
     * @param fileName Nome do ficheiro
     * @param primaryInvoice Indicador se é a fatura principal a ser enviada
     * @returns {void}
     */
    /**
     * Manipula o evento de arrastar (dragenter)
     * @param event - O evento de arrastar
     * @returns {void}
     */
    protected onDragEnter(event: DragEvent): void {
        this.preventDefaults(event);
        if (event.dataTransfer?.items && event.dataTransfer.items.length > 0) {
            this.isDragging = true;
        }
    }

    /**
    * Manipula o evento de saída do arrastar (dragleave)
    */
    protected onDragLeave(event: DragEvent): void {
        this.preventDefaults(event);
        this.isDragging = false;
    }

    /**
     * Manipula o evento de arrastar sobre o elemento (dragover)
     */
    protected onDragOver(event: DragEvent): void {
        this.preventDefaults(event);
        if (event.dataTransfer?.items && event.dataTransfer.items.length > 0) {
            this.isDragging = true;
        }
    }

    /**
     * Manipula o evento de soltar (drop)
     * @param event - O evento de soltar
     * @returns {void}
     */
    protected onDrop(event: DragEvent): void {
        this.preventDefaults(event);
        this.isDragging = false;

        if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
            const file = event.dataTransfer.files[0];
            this.handleFile(file);
        }
    }

    /**
     * Manipula a seleção de arquivo via input
     * @param event - O evento de seleção de arquivo
     * @returns {void}
     */
    protected onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            this.handleFile(file);
        }
    }

    /**
     * Processa o arquivo selecionado
     * @param file - O arquivo selecionado
     * @returns {void}
     */
    private handleFile(file: File): void {
        // Verifica o tipo de arquivo
        const allowedTypes = ['application/pdf'];
        if (!allowedTypes.includes(file.type)) {
            alert('Tipo de arquivo não suportado. Por favor, use PDF.');
            return;
        }

        // Verifica o tamanho do arquivo (10MB = 10 * 1024 * 1024 bytes)
        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            alert('O arquivo é muito grande. O tamanho máximo é 10MB.');
            return;
        }

        this.invoiceFile = file;
        this.uploadInvoice(file, true);
    }

    /**
     * Reset dados do ficheiro da fatura e o estado do upload
     * @returns {void}
     */
    protected resetUpload(): void {
        //Reset invoice data and status
        this.invoiceFile = null;
        this.invoiceFetchStatus.fetched = false;
        this.invoiceFetchStatus.successful = false;
        this.primaryInvoiceForm = null;

        //Reset entity controls
        this._newFormControls.entity.reset();

        //Remove the first element of the equipments arary, wich was added by invoice upload
        this._newElectricityEquipmentFormArrayControls.shift();
        this._newNaturalGasEquipmentFormArrayControls.shift();

        //Reset other entity
        this.otherEntity = {
            id: null,
            entity: null,
            permissions: {
                exists: false,
                tin: '',
                name: '',
                haveActiveContracts: false,
                id: ''
            }
        };

        //Force user to select tin in case of invoice missmatch
        this._newFormControls.isOwnTin.setValue(null);

        //Open file selection automatically to avoid user to click
        setTimeout(() => {
            // Make sure the element exists before trying to click it
            const fileInput = document.getElementById('file-upload') as HTMLInputElement;
            if (fileInput) {
                fileInput.click();
            }
        }, 100);
    }

    /**
     * Previne comportamentos dos eventos de arrastar
     * @param event - O evento de arrastar
     * @returns {void}
     */
    private preventDefaults(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
    }

    /**
     * Open file explorer to upload a file
     * @param event - The event object from the file input
     * @returns {void}
     */
    protected openFileExplorer(): void {
        const fileInput = document.getElementById('file-upload') as HTMLInputElement;
        if (fileInput) {
            fileInput.click();
        }
    }
    //#endregion

    //#region Stepper
    /**
    * Gets the current stepper progress
    * @returns {number} Progress in stepper 
    */
    protected get progressWidth(): number {
        return ((this.currentFormStep + 1) / this.steps.length) * 100;
    }

    /**
     * Goes foward in form
     * @returns {void} 
     */
    protected nextStep(): void {
        if (this.currentFormStep < this.steps.length - 1) {
            // Check if the current step is valid before proceeding
            switch (this.currentFormStep) {
                case 0:
                    //If invoice was uploaded and fetched
                    if (this.invoiceFetchStatus.successful) {
                        //We need to guarantee that the TIN is set in case of missmatch
                        if (this._newFormControls.isOwnTin.value === null) {
                            //Alert and block user from going forward
                            this._snackbarService.callSnackBar('TIN_SELECTION_REQUIRED', SnackBarType.WARNING);
                            return;
                        }
                    } else {
                        this._newFormControls.isOwnTin.setValue(true);
                    }
                    break;
                case 1:
                    // Check if tin is valid
                    if (this._newFormControls.entity.controls.tin.invalid) {
                        this._newFormControls.entity.controls.tin.setErrors({ required: true });
                        this._newFormControls.entity.controls.tin.markAsDirty();
                        this.scrollToInput('tin');
                        this._snackbarService.callSnackBar('ENTITY_DATA_REQUIRED', SnackBarType.WARNING);
                        return;
                    }

                    if (this._newFormControls.entity.controls.name.invalid) {
                        this._newFormControls.entity.controls.name.setErrors({ required: true });
                        this._newFormControls.entity.controls.name.markAsDirty();
                        this.scrollToInput('name');
                        this._snackbarService.callSnackBar('ENTITY_DATA_REQUIRED', SnackBarType.WARNING);
                        return;
                    }

                    // Check if grouping is set
                    if (!this._newFormControls.groupingId.value) {
                        this._newFormControls.groupingName.setErrors({ required: true });
                        this._newFormControls.groupingName.markAsDirty();
                        this.scrollToInput('groupingName');
                        this._snackbarService.callSnackBar('GROUPING_MARKET_REQUIRED', SnackBarType.WARNING);
                        return;
                    }

                    // Check if expected start date is set
                    if (!this._newFormControls.contractType.value) {
                        this._newFormControls.contractType.setErrors({ 'incorrect': true });
                        this._newFormControls.contractType.markAsDirty();
                        this.scrollToInput('contractType');
                        this._snackbarService.callSnackBar('CONTRACT_TYPE_REQUIRED', SnackBarType.WARNING);
                        return;
                    }

                    // Check if expected start date is set
                    if (!this._newFormControls.expectedStartDate.value) {
                        this._newFormControls.expectedStartDate.setErrors({ 'incorrect': true });
                        this._newFormControls.expectedStartDate.markAsDirty();
                        this.scrollToInput('expectedStartDate');
                        this._snackbarService.callSnackBar('PREDICTED_START_DATE_REQUIRED', SnackBarType.WARNING);
                        return;
                    }

                    break;
            }

            this.currentFormStep++;
            this.updateShadows();
        }
    }

    /**
     * Go back in form
     * @returns {void} 
     */
    protected previousStep(): void {
        if (this.currentFormStep > 0) {
            this.currentFormStep--;
            this.updateShadows();
        }
    }

    /**
     * Goes to a specific step in the form
     * @param {number} step Step number to go to
     * @returns {void}
     */
    protected goToStep(step: number): void {
        this.currentFormStep = step;
    }
    //#endregion Stepper

    selectEquipment(index: number): void {
        this.cancelAddEquipment();
        this.selectedEquipmentIndex = index;
        this.selectedEquipmentFormGroup = this._equipmentFormArrayControls[index];

        // Initialize tab if not set
        if (this.equipmentSelectedTabs[index] === undefined) {
            this.equipmentSelectedTabs[index] = 0;
        }

        if(this.selectedEquipmentFormGroup?.value.equipmentId){
            if(this.formGroupIsNaturalGas(this.selectedEquipmentFormGroup.controls)){
                this._energyMetersService.getNaturalGasMeterByCode(this.selectedEquipmentFormGroup.controls.equipmentCode.controls.finalValue.value!).pipe(takeUntil(this._destroy$)).subscribe((meter: any)=>{                    
                    this.selectedEquipmentFormGroup?.controls.postalCode.setValue({
                        finalValue: meter.data.address.postalCode,
                        invoiceValue: null,
                        serverValue: null,
                        comparisonResult: null,
                        finalId: null,
                        invoiceId: null,
                        serverId: null
                    });

                    this.onZipCodeFilled();
                });
            }
            else if(this.formGroupIsElectricity(this.selectedEquipmentFormGroup.controls)){
                this._energyMetersService.getElectricityMeterByCode(this.selectedEquipmentFormGroup.controls.equipmentCode.controls.finalValue.value!).pipe(takeUntil(this._destroy$)).subscribe((meter: any)=>{                    
                    this.selectedEquipmentFormGroup?.controls.postalCode.setValue({
                        finalValue: meter.data.address.postalCode,
                        invoiceValue: null,
                        serverValue: null,
                        comparisonResult: null,
                        finalId: null,
                        invoiceId: null,
                        serverId: null
                    });

                    this.selectedEquipmentFormGroup?.controls.postalCodeId.setValue(meter.data.address.postalCodeId);
                    this.onZipCodeFilled();
                    
                    this.selectedEquipmentFormGroup?.controls.parish.controls.finalValue.setValue(meter.data.address.parishId);
                    this.selectedEquipmentFormGroup?.controls.door.controls.finalValue.setValue(meter.data.address.doorNumber);
                    this.selectedEquipmentFormGroup?.controls.floor.controls.finalValue.setValue(meter.data.address.floorFraction);
                    this.selectedEquipmentFormGroup?.controls.street.controls.finalValue.setValue(meter.data.address.street);
                    this.selectedEquipmentFormGroup?.controls.door.disable();
                    this.selectedEquipmentFormGroup?.controls.floor.disable();
                    this.selectedEquipmentFormGroup?.controls.street.disable();

                    
                });
            }
        }

        this.scrollTop('equipmentContent');
    }

    removeEquipment(index: number): void {
        const targetControl = this._equipmentFormArrayControls[index];

        // Check which type it is and remove from the corresponding array
        if (this.formGroupIsElectricity(targetControl.controls)) {
            const electricityIndex = this._newElectricityEquipmentFormArrayControls.findIndex(ctrl => ctrl === targetControl);
            if (electricityIndex > -1) {
                this._newElectricityEquipmentFormArrayControls.splice(electricityIndex, 1);
            }
        } else {
            const gasIndex = this._newNaturalGasEquipmentFormArrayControls.findIndex(ctrl => ctrl === targetControl);
            if (gasIndex > -1) {
                this._newNaturalGasEquipmentFormArrayControls.splice(gasIndex, 1);
            }
        }

        // remove parish options for that index as well so arrays stay in sync
        this.parishOptions.splice(index, 1);

        // If this was the selected equipment, select another one or clear selection
        if (this.selectedEquipmentIndex === index) {
            const nextValidIndex = this.getNextValidEquipmentIndex(index);
            if (nextValidIndex !== null) {
                this.selectEquipment(nextValidIndex);
            } else {
                this.selectedEquipmentIndex = null;
                this.selectedEquipmentFormGroup = null;
            }
        }
    }

    getNextValidEquipmentIndex(excludeIndex: number): number | null {
        for (let i = 0; i < this._equipmentFormArrayControls.length; i++) {
            if (i !== excludeIndex) {
                return i;
            }
        }
        return null;
    }

    getValidEquipmentCount(): number {
        return this._equipmentFormArrayControls.filter(equipment =>
            this.isEquipmentValid(equipment)
        ).length;
    }

    getEquipmentsWithErrors(): number {
        return this._equipmentFormArrayControls.filter(equipment =>
            this.hasEquipmentErrors(equipment)
        ).length;
    }

    isEquipmentValid(equipmentFormGroup: FormGroup): boolean {
        return equipmentFormGroup.valid;
    }

    hasEquipmentErrors(equipmentFormGroup: FormGroup): boolean {
        return equipmentFormGroup.invalid && equipmentFormGroup.touched;
    }

    showAddEquipmentInterface(): void {
        this.addEquipmentType = null; // Will be detected dynamically
        this.showingAddInterface = true;
        this.selectedEquipmentIndex = null;
        this.selectedEquipmentFormGroup = null;
        this.resetAddEquipmentForm();
        this.setupDynamicCodeValidation();
    }

    cancelAddEquipment(): void {
        this.showingAddInterface = false;
        this.resetAddEquipmentForm();
    }

    confirmAddEquipment(): void {
        if (this.addEquipmentGroup.valid || this.addEquipmentInvoiceFile) {
            // Set the equipment code if provided
            if (this.addEquipmentGroup.controls.equipmentCode.value) {
                const newIndex = this._equipmentFormArrayControls.length - 1;
                const newEquipment = this._equipmentFormArrayControls[newIndex];
                newEquipment.controls.equipmentCode.controls.finalValue.setValue(this.addEquipmentGroup.controls.equipmentCode.value);
            }

            // Select the newly created equipment
            const newIndex = this._equipmentFormArrayControls.length - 1;
            this.selectEquipment(newIndex);
            this.showingAddInterface = false;
            this.resetAddEquipmentForm();
        }
    }

    resetAddEquipmentForm(): void {
        this.addEquipmentGroup.reset();
        this.addEquipmentInvoiceFile = null;
        this.isDragging = false;
    }

    private setupDynamicCodeValidation(): void {
        this.addEquipmentGroup.controls.equipmentCode.clearValidators();

        this.addEquipmentGroup.controls.equipmentCode.valueChanges.pipe(
            debounceTime(500),
            distinctUntilChanged()
        ).subscribe(value => {
            const trimmed = value?.trim();
            this.addEquipmentGroup.controls.equipmentCode.setErrors({ invalidEquipmentCode: true });
            if (!trimmed) {
                this.addEquipmentType = null;
                this.addEquipmentGroup.controls.equipmentCode.setValidators([Validators.required]);
                this.addEquipmentGroup.controls.equipmentCode.updateValueAndValidity();
                return;
            }

            const electricityRegex = this._meterCodeRegexpPattern(true);
            const gasRegex = this._meterCodeRegexpPattern(false);

            if (electricityRegex.test(trimmed)) {
                this.addEquipmentType = 'electricity';
                this.addEquipmentGroup.controls.equipmentCode.setErrors(null);
                this.addEquipmentGroup.controls.equipmentCode.setValidators([
                    Validators.required,
                    Validators.pattern(electricityRegex)
                ]);
            } else if (gasRegex.test(trimmed)) {
                this.addEquipmentType = 'gas';
                this.addEquipmentGroup.controls.equipmentCode.setErrors(null);
                this.addEquipmentGroup.controls.equipmentCode.setValidators([
                    Validators.required,
                    Validators.pattern(gasRegex)
                ]);
            } else {
                this.addEquipmentType = null;
                this.addEquipmentGroup.controls.equipmentCode.setValidators([Validators.required]);
            }

            // Delay fetching until after validators apply
            setTimeout(() => {
                if (this.addEquipmentGroup.controls.equipmentCode.valid && trimmed) {
                    this.addEquipment(trimmed, null);
                }
            });
        });

        // Initial fallback validator
        this.addEquipmentGroup.controls.equipmentCode.setValidators([Validators.required]);
        this.addEquipmentGroup.controls.equipmentCode.updateValueAndValidity();
    }
    //#endregion

    //#endregion Invoice File ------------------------------------

    //#region Auxiliar Functions
    onZipCodeFilled(){
        let zipCodeGroup = this.selectedEquipmentFormGroup?.controls?.postalCode?.controls?.finalValue;
        if( zipCodeGroup?.value && zipCodeGroup?.value.length > 0 ){
            let zipCode: string;
            zipCode = zipCodeGroup?.value ?? '';
            (this.countryCode == 'PT' ? this._addressService.getPostalCodePT(zipCode) : this._addressService.getPostalCodeES(zipCode)).pipe(takeUntil(this._destroy$)).subscribe((sr: ServerResponse<any>) => {
                if (sr.data) {
                    this.selectedEquipmentFormGroup?.controls?.postalCodeId?.setValue(sr.data.id);

                    this.selectedEquipmentFormGroup?.controls?.county?.setValue({
                        finalValue: sr.data.county,
                        invoiceValue: null,
                        serverValue: null,
                        comparisonResult: null,
                    });
                    this.selectedEquipmentFormGroup?.controls?.district?.setValue({
                        finalValue: sr.data.district,
                        invoiceValue: null,
                        serverValue: null,
                        comparisonResult: null,
                    });
                    this.selectedEquipmentFormGroup?.controls?.locality?.setValue({
                        finalValue: sr.data.locality,
                        invoiceValue: null,
                        serverValue: null,
                        comparisonResult: null,
                    });
                    this.selectedEquipmentFormGroup?.controls?.county?.disable();
                    this.selectedEquipmentFormGroup?.controls?.district?.disable();
                    this.selectedEquipmentFormGroup?.controls?.locality?.disable();

                    this._addressService.getParishes(sr.data.fkCounty).pipe(takeUntil(this._destroy$)).subscribe((parishes: ServerResponse<any[]>) => {
                        if (parishes.data?.length) {
                            const idx = this.selectedEquipmentIndex ?? 0;
                            // make sure the array has the slot
                            this.parishOptions[idx] = parishes.data.map( (parish) => new ISSelectOption(parish.id, parish.name));
                            this._cdref.detectChanges();
                        }
                    });
                }
            });
        }
    }

    private scrollTop(id: string) {
        const div = document.getElementById(id) as HTMLElement;

        if (div) {
            div.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }

    private scrollToInput(id: string) {
        const input = document.getElementById(id) as HTMLInputElement;

        if (input) {
            input.focus();
            input.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });

            input.classList.add('invalid-input');

            setTimeout(() => {
                input.classList.remove('invalid-input');
            }, 1000);

        }
    }

    private buildComparisonGroup<T>(
        invoiceVal: T | null,
        serverVal: T | null,
        options?: FormControlOptions | ValidatorFn | ValidatorFn[],
        id?: number | string | null
    ): FormGroup<DataComparisonFormGroup<T>> & { id?: FormControl<number | string | null> } {
        const result: 'match' | 'mismatch' | 'notFound' | null =
            invoiceVal === null ? 'notFound' : invoiceVal === serverVal ? 'match' : 'mismatch';

        const normalizedOptions: FormControlOptions = this.normalizeControlOptions(options);

        const group = this._fb.group({
            invoiceValue: this._fb.control<T | null>(invoiceVal, normalizedOptions),
            serverValue: this._fb.control<T | null>(serverVal, normalizedOptions),
            finalValue: this._fb.control<T | null>(serverVal ?? invoiceVal ?? null, normalizedOptions),
            comparisonResult: this._fb.control<'match' | 'mismatch' | 'notFound' | null>(result)
        });

        if (id !== undefined) {
            (group as any).addControl('id', this._fb.control(id));
        }


        return group as FormGroup<DataComparisonFormGroup<T>> & { id?: FormControl<number | string | null> };
    }

    private normalizeControlOptions(
        options?: FormControlOptions | ValidatorFn | ValidatorFn[]
    ): FormControlOptions {
        if (!options) return {};

        if (Array.isArray(options)) {
            return { validators: options };
        }

        if (typeof options === 'function') {
            return { validators: [options] };
        }

        return options;
    }

    protected get _newFormControls(): NewOpportunityFormGroup {
        return this.newOpportunityForm.controls;
    }

    protected get _newElectricityEquipmentFormArrayControls(): FormGroup<ElectricityEquipmentFormGroup>[] {
        return this.newOpportunityForm.controls.electricityEquipments.controls;
    }

    protected get _newNaturalGasEquipmentFormArrayControls(): FormGroup<NaturalGasEquipmentFormGroup>[] {
        return this.newOpportunityForm.controls.naturalGasEquipments.controls;
    }

    protected get _equipmentFormArrayControls(): FormGroup<ElectricityEquipmentFormGroup | NaturalGasEquipmentFormGroup>[] {
        let arr: any[] = [];
        arr.push(...this.newOpportunityForm.controls.electricityEquipments.controls);
        arr.push(...this.newOpportunityForm.controls.naturalGasEquipments.controls);

        return arr;
    }

    protected get _userData(): ClientPortalUser {
        return this._userService.userData!;
    }

    protected get _primaryInvoiceElectricityEquipmentData(): FormGroup<ElectricityEquipmentFormGroup> | undefined {
        const found = this._newFormControls.electricityEquipments.controls.find(
            (fg) => fg.get('invoiceData.isPrimaryInvoice')?.value === true
        );
        return found;
    }

    protected get _primaryInvoiceNaturalGasEquipmentData(): FormGroup<NaturalGasEquipmentFormGroup> | undefined {
        return this._newFormControls.naturalGasEquipments.controls.find(
            (fg) => fg.get('invoiceData.isPrimaryInvoice')?.value === true
        );
    }

    private codeAlreadyExists(equipmentCode: string): boolean {
        return this._newElectricityEquipmentFormArrayControls.filter((fg: FormGroup<ElectricityEquipmentFormGroup>) => fg.controls.equipmentCode.value.finalValue == equipmentCode).length > 0;
    }

    // Newly created equipments carry the invariant description in lowercase (e.g. "bihourly"), while the i18n keys are camelCase ("biHourly")
    protected getCountTypeLabelKey(countType: string | null | undefined): string {
        const keys: { [lowercased: string]: string } = { simple: 'simple', simples: 'simple', bihourly: 'biHourly', trihourly: 'triHourly' };

        return keys[(countType ?? '').toLowerCase().replace(/[-_\s]/g, '')] ?? countType ?? '';
    }

    protected formGroupIsElectricity(formGroupControls: ElectricityEquipmentFormGroup | NaturalGasEquipmentFormGroup): formGroupControls is ElectricityEquipmentFormGroup {
        return (formGroupControls as ElectricityEquipmentFormGroup).tensionLevel != null;
    }

    protected formGroupIsNaturalGas(formGroupControls: ElectricityEquipmentFormGroup | NaturalGasEquipmentFormGroup): formGroupControls is NaturalGasEquipmentFormGroup {
        return (formGroupControls as NaturalGasEquipmentFormGroup).pressureLevel != null;
    }

    private _meterCodeRegexpPattern(isElectricity: boolean): RegExp {
        if (isElectricity) {
            if (this.countryCode == 'PT') {
                return new RegExp(RegExpPatterns.elecEquipmentPT);
            } else {
                return new RegExp(RegExpPatterns.elecEquipmentES);
            }
        } else {
            if (this.countryCode == 'PT') {
                return new RegExp(RegExpPatterns.ntrlGasEquipmentPT);
            } else {
                return new RegExp(RegExpPatterns.ntrlGasEquipmentES);
            }
        }
    }

    public _zipCodeRegexpPattern(): RegExp {
        if (this.countryCode == 'PT') {
            return new RegExp(RegExpPatterns.postalCodePT);
        } else {
            return new RegExp(RegExpPatterns.postalCodeES);
        }
    }

    /**
     * Updates contract type based on the first digit of the TIN.
     */
    private _setContractTypeFromTin(tin: number): void {
        const firstDigit = parseInt(tin.toString()[0], 10);

        const personalType = contractTypes.find(x => x.invariantCultureDescription === 'Personal');
        const businessType = contractTypes.find(x => x.invariantCultureDescription === 'Business');

        if (!personalType || !businessType) return;

        const isPersonalTIN = [0, 1, 2, 7].includes(firstDigit);
        const isBusinessTIN = [5, 6, 8, 9].includes(firstDigit);


        if (isPersonalTIN) {
            this._newFormControls.contractType.setValue(environment.contractTypeIds.Personal);
        } else if (isBusinessTIN) {
            this._newFormControls.contractType.setValue(environment.contractTypeIds.Business);
        }
    }

    /**
     * Checks whether a TIN is non-empty, not null, and not just whitespace.
     */
    private _isTINValid(tin: number | string | null, countryCode?: string): boolean {
        // Convert to string and clean up
        const tinStr = (tin?.toString() || '').replace(/\s/g, '');

        // If no TIN provided, it's invalid
        if (!tinStr || tinStr.trim().length === 0) {
            return false;
        }

        // If country code is not provided, try to guess based on format
        // or validate using generic rules
        if (!countryCode) {
            // Default validation - at least 5 characters, alphanumeric
            return tinStr.length >= 5 && /^[a-zA-Z0-9]+$/.test(tinStr);
        }

        // Normalize country code
        const country = countryCode.toUpperCase();

        // Country-specific validation
        switch (country) {
            case 'PT': // Portugal
                // NIF: 9 digits, last digit is check digit
                if (!/^\d{9}$/.test(tinStr)) {
                    return false;
                }

                return true;

            case 'ES': // Spain
                // NIF/NIE: Letter + 7 digits + check letter, or 8 digits + check letter
                if (!/^[0-9A-Z][0-9]{7}[A-Z]$/.test(tinStr)) {
                    return false;
                }

                const letterMap = 'TRWAGMYFPDXBNJZSQVHLCKE';
                let number = tinStr.substr(0, 8);

                // Handle NIE (foreigner ID)
                if (isNaN(parseInt(number[0]))) {
                    const firstChar = number[0];
                    if (firstChar === 'X') number = '0' + number.substr(1);
                    else if (firstChar === 'Y') number = '1' + number.substr(1);
                    else if (firstChar === 'Z') number = '2' + number.substr(1);
                    else return false;
                }

                return true;
            default:
                return tinStr.length >= 5 && /^[a-zA-Z0-9]+$/.test(tinStr);
        }
    }

    protected onScroll(): void {
        this.updateShadows();
    }

    private updateShadows(): void {
        const el = this.scrollableContent?.nativeElement;

        const hasScrollableContent = el.scrollHeight > el.clientHeight;

        if (!hasScrollableContent) {
            // No overflow, hide all shadows
            this.showFooterShadow = false;
            this.showStepperShadow = false;
            return;
        }

        // Overflow exists, update shadows based on scroll position
        this.showStepperShadow = el.scrollTop > 0;
        this.showFooterShadow = el.scrollTop + el.clientHeight < el.scrollHeight;
    }
    //#endregion
}

function foreach() {
    throw new Error('Function not implemented.');
}
